export default { searchTag: 'جستجوی برچسب' };
